import React, { useState } from "react";
import { ImprovedProduct } from "../../Interfaces/Product";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../contexts/Cart/CartContext";
import {
  DesignFile,
  FundraiserParticipantShop,
  ImprovedParticipantShop,
} from "../../Interfaces/FundraiserRole";
import { generateUniqueId } from "../../Interfaces/Types";
import { logoOverlayFetcher } from "../../pages/ImprovedShopPage/SingleProductPageHelpers";
import { Category } from "../../../src/CommonFunctions";
import { ImprovedParticipant } from "../../Interfaces/FundraiserRole";
import { useMediaQuery } from "@mui/material";
import "./ProductCard.css";

interface DesignCardProps {
  iter: string;
  product: ImprovedProduct;
  design: DesignFile;
  participantID: string;
  shopInfo: ImprovedParticipantShop;
  isFromSamplePage?: boolean;
}

const DesignCard: React.FC<DesignCardProps> = ({
  iter,
  product,
  design,
  participantID,
  shopInfo,
  isFromSamplePage = false,
}) => {
  const navigate = useNavigate();

  const isSmall = useMediaQuery("(max-width:600px)");
  const isMedium = useMediaQuery("(max-width:960px)");

  const { state, dispatch } = useCart();
  const participant = shopInfo.participant;
  const [isHovered, setIsHovered] = useState(false);

  const baseImage = design.file_location;
  const logoImage = product.images[0];

  const getCategory = (): Category => {
    if (!shopInfo.sku_by_category) return Category.Default;

    for (const [category, skus] of Object.entries(shopInfo.sku_by_category)) {
      if (Array.isArray(skus) && skus.includes(Number(product.sku))) {
        return category as Category;
      }
    }
    return Category.Default;
  };

  const category = getCategory();
  const overlayStyle = logoOverlayFetcher(category, false);

  const handleNavigateToProduct = () => {
    navigate(`/refactored-product/${product.sku}`, {
      state: {
        shopInfo: shopInfo,
        participantID,
        customImage: design.file_location,
        isFromSamplePage: isFromSamplePage,
      },
    });
  };

  const defaultImage =
    "https://stg-mamfam-data.s3.amazonaws.com/static/placeholder-product-image.png";
  const imageUrl = design ? design.file_location : defaultImage;

  return (
    <div
      className="product-card bg-white rounded shadow-sm"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="product-card__image-container">
        <img
          src={baseImage}
          alt={product.name}
          className="product-card__image"
          style={{ opacity: isHovered ? 0.9 : 1 }}
        />
        {
          //This is the hover image code.
          /*isHovered && logoImage && logoImage !== baseImage && (
            <img
              src={logoImage}
              alt="Customization Preview"
              style={{
                position: "absolute",
                width: overlayStyle?.width || "60%",
                height: "auto",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                ...overlayStyle,
                pointerEvents: "none",
                opacity: 0.9,
              }}
            />
          )*/
        }
      </div>
      <div className="product-card__content">
        <p className="product-card__title">{design.file_name}</p>

        <Button
          variant="contained"
          fullWidth
          onClick={(e) => {
            e.stopPropagation();
            handleNavigateToProduct();
          }}
          style={{ marginTop: "auto" }}
        >
          Customize Now
        </Button>
      </div>
    </div>
  );
};

export default DesignCard;
